import { Record } from "immutable";

export type DropdownsType = {
  childUserIdInitialised: boolean;
  childUserId: string | null;
  startTime: string | null;
  endTime: string | null;
  isCustomPeriod: boolean;
};

const defaultDropdowns: DropdownsType = {
  childUserIdInitialised: false,
  childUserId: null,
  startTime: null,
  endTime: null,
  isCustomPeriod: false
};

export default class Dropdowns extends Record(defaultDropdowns) {}
